import Axios from 'axios'
import {VolunteerContactUrls} from './../urls'
import router from '../../../router'

export default {
  get_all_volunteer_contacts (context, programId) {
    Axios.get(VolunteerContactUrls.getAllVolunteer_contacts + programId).then(function (response) {
      context.commit('GET_ALL_VOLUNTEER_CONTACTS', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_ALL_VOLUNTEER_CONTACTS', data)
    })
  },
  get_deleted_volunteer_contacts (context) {
    Axios.get(VolunteerContactUrls.getDeletedVolunteer_contacts).then(function (response) {
      context.commit('GET_DELETED_VOLUNTEER_CONTACTS', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_DELETED_VOLUNTEER_CONTACTS', data)
    })
  },
  get_volunteercontact (context, publicId) {
    Axios.get(VolunteerContactUrls.getVolunteercontact + publicId).then(function (response) {
      context.commit('GET_VOLUNTEERCONTACT', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_VOLUNTEERCONTACT', data)
    })
  },
  post_volunteercontact (context, data) {
    Axios.post(VolunteerContactUrls.postVolunteercontact, data).then(function (response) {
      context.dispatch('get_all_volunteer_contacts', data.program_id)
      router.push({
        name: data.redirect_url
      })
    })
  },
  update_volunteercontact (context, data) {
    Axios.post(VolunteerContactUrls.editVolunteercontact, data).then(function (response) {
      context.dispatch('get_all_volunteer_contacts', data.program_id)
      router.push({
        name: data.redirect_url
      })
    })
  },
  delete_volunteercontact (context, data) {
    Axios.delete(VolunteerContactUrls.deleteVolunteercontact + data.public_id).then(function (response) {
      context.dispatch('get_all_volunteer_contacts', data.program_id)
    })
  },
  restore_volunteercontact (context, publicId) {
    Axios.get(VolunteerContactUrls.restoreVolunteercontact + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_VOLUNTEER_CONTACTS', response.data)
      router.push({
        name: 'Module.Volunteer_contacts'
      })
    })
  }
}
